export { ImageStaticAds } from "./ImageStaticAds";